import type { Berichtsanzeige } from './auswertung';

/**
 * DIE ANZEIGE EINES BERICHTS (Auftrag CRM-47) — eine Vorgabe fuer Maske,
 * PDF und Widget.
 *
 * OHNE EINFUHR zur Laufzeit, wie `achsen.ts`: Die Oberflaeche fuehrt diese
 * Datei ueber ihren Quellpfad ein (`@crm/kontrakte/src/anzeige`), die API
 * ueber das Paket. Der Typ kommt aus dem Pruefer (`berichtsanzeige`) und
 * verschwindet beim Uebersetzen.
 */

/**
 * Die Darstellung vor Fassung 5: Legende, Gitter, Achsentitel, Vergleiche
 * und Zielwerte im Bild, die Summen in der Tabelle, die Tabelle offen.
 * `werte` fehlt mit Absicht — ohne Angabe setzt jede Ausgabe sie wie bisher.
 */
export const VORGABE_ANZEIGE: Berichtsanzeige = {
  legende: true,
  gitter: true,
  achsentitel: true,
  vergleiche: true,
  ziele: true,
  summen: true,
  tabelle: 'offen',
};

/** Die Anzeige einer Beschreibung; ohne Angabe (Fassung 1 bis 4) die von vorher. */
export function anzeigeVon(b: { readonly anzeige?: Berichtsanzeige | undefined }): Berichtsanzeige {
  return b.anzeige ?? VORGABE_ANZEIGE;
}

/**
 * Ob die Anzeige die von vorher ist — fuer den Vergleich zweier
 * Beschreibungen: Eine ohne Angabe und eine mit der Vorgabe zeigen dasselbe.
 */
export function anzeigeGleich(a: Berichtsanzeige | undefined, b: Berichtsanzeige | undefined): boolean {
  const x = a ?? VORGABE_ANZEIGE;
  const y = b ?? VORGABE_ANZEIGE;
  return (
    x.legende === y.legende
    && x.werte === y.werte
    && x.gitter === y.gitter
    && x.achsentitel === y.achsentitel
    && x.vergleiche === y.vergleiche
    && x.ziele === y.ziele
    && x.summen === y.summen
    && x.tabelle === y.tabelle
    && optionenGezeigt(x) === optionenGezeigt(y)
  );
}

/**
 * AUS-34 (Auftrag CRM-92, ÄA-56): ob das Diagramm die gewaehlten
 * Kennzahloptionen mitzeichnet. Ohne Angabe ja — auch in Berichten vor
 * Fassung 9.
 */
export function optionenGezeigt(a: Berichtsanzeige): boolean {
  return a.optionen !== false;
}
